// ยุบการสลับตัวหนา/ตัวปกติที่เดิมกระจายเป็นหลาย doc.text ให้เหลือฟังก์ชันเดียว
// วาดข้อความผสม "ตัวปกติ + ตัวหนา" ต่อกันในบรรทัดเดียว แล้วตัดขึ้นบรรทัดใหม่ให้อัตโนมัติ
// (กันตัวหนังสือตกขอบ) — ใช้ซ้ำได้ทุกจดหมาย
//
// segments: อาร์เรย์ของ
//   - string           => ตัวปกติ
//   - { text, bold }   => ตัวหนา (ใช้ผ่านตัวช่วย b("...") ด้านล่าง)
// ช่องว่างระหว่างช่วงให้ใส่เป็นเว้นวรรคในสตริงตัวปกติ (ช่วงตัวหนาไม่ต้องมีเว้นวรรคหุ้ม)

export function b(text) {
    return { text: String(text ?? ""), bold: true };
}

export function drawRichText(
    doc,
    x,
    y,
    maxWidth,
    lineHeight,
    segments,
    font = "THSarabunNew"
) {
    let curX = x;

    for (const seg of segments) {
        const text = typeof seg === "string" ? seg : seg.text;
        const isBold = typeof seg === "object" && seg.bold;
        doc.setFont(font, isBold ? "bold" : "normal");

        const spaceW = doc.getTextWidth(" ");
        const tokens = String(text).split(" ");

        for (let i = 0; i < tokens.length; i++) {
            const word = tokens[i];
            const isLast = i === tokens.length - 1;

            // สตริงว่าง = ช่องว่าง (รวมถึงช่องย่อหน้า) แค่ขยับ x
            if (word === "") {
                curX += spaceW;
                continue;
            }

            const wordW = doc.getTextWidth(word);

            // ถ้าคำถัดไปจะเลยขอบขวา ให้ขึ้นบรรทัดใหม่ (ยกเว้นตอนต้นบรรทัด)
            if (curX > x && curX + wordW > x + maxWidth) {
                curX = x;
                y += lineHeight;
            }

            doc.text(word, curX, y);
            curX += wordW + (isLast ? 0 : spaceW);
        }
    }

    doc.setFont(font, "normal");
    return y; // ตำแหน่ง y ของบรรทัดสุดท้ายที่วาด
}
